import { faPaperPlane, faTimesCircle, faCheckDouble, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import React, { FunctionComponent } from 'react';
import ConfirmationModal, { useConfirmationModal } from '../../../../common/components/ConfirmationModal';
import { Translate } from 'react-localize-redux';
import ActionIcon from '../../../../common/components/ActionIcon';
import { isBankReportReadOnly, hasBankIntegrtaion } from '../../helpers/transactionsLogic';
import { BankStatus } from '../../../../common/models/BankStatus';
import { Bank } from '../../models/Bank';
import { Transaction } from '../../models/Transaction';
import { ProductType } from '../../../../common/models/ProductType';

interface BankRepliesButtonsProps {
    selectionMode: boolean;
    selectedBankIds: number[];
    editMode: boolean;
    canEnterEdit: boolean;
    banks: Bank[];
    transactions: Transaction[];
    productType: ProductType | null;
    isRefreshing: boolean;
    onRefresh: () => void;
    setSelectionMode(selectionMode: boolean): void;
    setSelectedBankIds(selectedBankIds: number[]): void;
    addAutomaticBankReport(selectedBankIds: number[], actionKey: string): void;
    createEmptyTransaction(bankId: number): Transaction;
}

const BankRepliesButtons: FunctionComponent<BankRepliesButtonsProps> = (props) => {
    const onConfirm = () => {
        props.addAutomaticBankReport(props.selectedBankIds, 'SEND_MANY');
        props.setSelectionMode(false);
        props.setSelectedBankIds([]);
    };
    const [modalProps, showModal] = useConfirmationModal(<Translate id="SEND_MANY" />, <Translate id="SEND_MANY_CONFIRMATION" />, onConfirm);

    return (
        <React.Fragment>
            {renderSelectionButtons(props, showModal)}
            <ConfirmationModal {...modalProps} />
        </React.Fragment>
    );
};

function renderSelectionButtons(props: BankRepliesButtonsProps, showModal: () => void) {
    if (props.selectionMode) {
        const onCancel = () => {
            props.setSelectionMode(false);
            props.setSelectedBankIds([]);
        };

        const isDisabled = props.selectedBankIds.length === 0 || props.editMode || !props.canEnterEdit
            || props.selectedBankIds.some((bid) => !checkIfCanSend(bid, props));

        return (
            <div>
                <ActionIcon
                    action={showModal}
                    icon={faPaperPlane}
                    tooltipKey="SEND_MANY"
                    disabled={isDisabled}
                />
                <ActionIcon
                    action={onCancel}
                    icon={faTimesCircle}
                    tooltipKey="CANCEL"
                />
            </div>
        );
    }

    const onSwitch = () => props.setSelectionMode(true);
    return (
        <div>
            <ActionIcon
                action={props.onRefresh}
                icon={faSyncAlt}
                iconSpin={props.isRefreshing}
                tooltipKey="REFRESH"
                disabled={props.isRefreshing}
            />
            <ActionIcon
                action={onSwitch}
                icon={faCheckDouble}
                tooltipKey="SELECT_MANY_BANKS"
                disabled={!props.canEnterEdit}
            />
        </div>
    );
}

function checkIfCanSend(bankId: number, props: BankRepliesButtonsProps) {
    const bank = props.banks.find((b) => b.id === bankId);
    const transaction = props.transactions.find((t) => t.bankId === bankId) || props.createEmptyTransaction(bankId);
    return !isBankReportReadOnly(transaction) && bank && hasBankIntegrtaion(bank, props.productType) &&
        (transaction.id === null || // send
            (transaction.bankReportId !== undefined && transaction.bankStatus !== BankStatus.Paid && transaction.bankStatus !== BankStatus.Denied) // resend
        );
}

export default BankRepliesButtons;
